/**
 * Trigger a same-origin authenticated file download without losing the
 * user gesture (fetch→blob→click often gets blocked after await).
 */
export function triggerAuthenticatedDownload(url: string, filename: string): void {
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  a.rel = "noopener"
  a.style.display = "none"
  document.body.appendChild(a)
  a.click()
  a.remove()
}
